var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5927_17614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7213 8.69254C21.1254 8.69254 23.0744 6.74665 23.0744 4.34627C23.0744 1.94589 21.1254 0 18.7213 0C16.3171 0 14.3682 1.94589 14.3682 4.34627C14.3682 6.74665 16.3171 8.69254 18.7213 8.69254Z",
    fill: "#73F0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5092 26.5966H19.6307V32.3051H0.0742188L9.17025 18.6825H1.30868V12.9739H20.5403L11.5092 26.5966Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5927_17614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32.8421,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportFace);
export default __webpack_public_path__ + "static/media/support-face.3447189cd04b41960f21ecfdf5985511.svg";
export { ForwardRef as ReactComponent };